import { render, staticRenderFns } from "./AgeRatingPickerModal.vue?vue&type=template&id=fb97bf66&scoped=true"
import script from "./AgeRatingPickerModal.vue?vue&type=script&lang=js"
export * from "./AgeRatingPickerModal.vue?vue&type=script&lang=js"
import style0 from "./AgeRatingPickerModal.vue?vue&type=style&index=0&id=fb97bf66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb97bf66",
  null
  
)

export default component.exports